<template>
    <div>
        <div v-show="mostrarMenu">
            <b-card no-body>
                <b-card-header>
                    <h5>Relatórios</h5>
                </b-card-header>
                <b-card-body>
                    <relatorios-gescon></relatorios-gescon>
                    <relatorios-credenciados></relatorios-credenciados>
                    <relatorios-sgtec></relatorios-sgtec>
                    <paineis-menu></paineis-menu>
                    <avaliacoes-menu></avaliacoes-menu>
                    <relatorios-tcu></relatorios-tcu>
                </b-card-body>
            </b-card>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
import RelatoriosCredenciados from './../credenciados/relatorios/Relatorios'
import RelatoriosSgtec from './../sgtec/relatorios/Relatorios'
// import RelatoriosServicos from './RelatoriosServicos'
import RelatoriosGescon from './../gescon/relatoriosservicos/Relatorios.vue'
import PaineisMenu from './../paineis/PaineisMenu.vue'
import AvaliacoesMenu from './../despesasgerais/avaliacoes/AvaliacoesMenu.vue'
import RelatoriosTcu from './../tcu/relatorios/Relatorios.vue'

export default {
    components: {
        RelatoriosCredenciados,
        RelatoriosSgtec,
        PaineisMenu,
        RelatoriosTcu,
        AvaliacoesMenu,
        RelatoriosGescon
    },

    computed: {
        mostrarMenu() {
            return this.$route.name == 'Relatorios'
        }
    }
}
</script>
